import { ReleaseStatusList } from './ReleaseStatusList';

export const ReleaseStatus = () => {
  return (
    <div className="mx-auto flex min-h-full w-full max-w-5xl shrink-0 flex-col">
      <ReleaseStatusList className="flex-1" />
    </div>
  );
};
